import React from 'react';
import LandingHeader from '../components/Landing/LandingHeader';
import LandingMainA from '../components/Landing/LandingMainA';
import LandingMainB from '../components/Landing/LandingMainB';
import LandingMainC from '../components/Landing/LandingMainC';
import LandingMainD from '../components/Landing/LandingMainD';
import LandingFooter from '../components/Landing/LandingFooter';

export default function LandingPage() {
  return (
    <div className="landing-bg">
      <div className="space-y-24 h-auto">
        <LandingHeader />
        <LandingMainA />
        <LandingMainB />
        <LandingMainC />
        <LandingMainD />
        <LandingFooter />
      </div>
    </div>
  );
}
